'use client';
import Image from 'next/image';
interface CustomImageProps {
  src: string;
  alt: string;
  style?: string;
  className?: string;
  width: number;
  height: number;
}

const CustomImage = ({
  src,
  alt,
  width = 0,
  height = 0,
  className = '',
}: CustomImageProps) => {
  // Validate URL

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading="lazy"
    />
  );
};

export default CustomImage;
